import { spacing } from '@mehilainen/mds-tokens';
import * as colors from '@mehilainen/mds-tokens/colors';
import { baseTypography } from '@mehilainen/mds-tokens/typography';
import { circularProgressClasses, } from '@mui/material';
import merge from 'lodash/merge';
import { focusVisible } from '../shared';
const getButtonStyles = (tokens) => ({
    defaultProps: {
        color: 'primary',
        variant: 'contained',
        size: 'medium',
    },
    styleOverrides: {
        root: ({ ownerState, theme }) => {
            var _a, _b, _c, _d, _e, _f, _g, _h;
            return (Object.assign(Object.assign(Object.assign({ minWidth: 'unset', boxShadow: 'none', textTransform: 'unset', borderRadius: tokens.uiElementButton.borderRadius, 
                // NOTE: MUI specifically tells in the console to do this like this instead of using focusVisible property in styleOverrides
                '&.Mui-focusVisible': Object.assign(Object.assign({}, focusVisible), { outlineOffset: '2px' }), 
                // NOTE: For some reason disabled property in overrides will not include these, that's why this is here
                // https://github.com/mui/material-ui/issues/29644
                '&.Mui-disabled': Object.assign({ color: ownerState.variant === 'contained' ? colors.White : colors.Gray600, borderColor: ownerState.variant === 'contained' ? colors.Gray600 : colors.Gray300 }, (((_a = ownerState.variant) === null || _a === void 0 ? void 0 : _a.startsWith('outlined')) && {
                    backgroundColor: 'unset',
                })) }, (((_b = ownerState.variant) === null || _b === void 0 ? void 0 : _b.startsWith('contained'))
                ? Object.assign({}, (ownerState.color === 'error'
                    ? {
                        '&:hover': {
                            boxShadow: 'unset',
                            backgroundColor: theme.palette.error.dark,
                        },
                        '&:active': {
                            boxShadow: 'unset',
                            backgroundColor: colors.Error800,
                            color: colors.Error200,
                        },
                    }
                    : ownerState.color === 'primary'
                        ? {
                            '&:hover': {
                                boxShadow: 'unset',
                                backgroundColor: theme.palette.primary.dark,
                            },
                            '&:active': {
                                boxShadow: 'unset',
                                backgroundColor: colors.Primary700,
                                color: colors.Primary200,
                            },
                        }
                        : {})) : {})), (((_c = ownerState.variant) === null || _c === void 0 ? void 0 : _c.startsWith('outlined'))
                ? Object.assign({ borderColor: colors.Gray300, backgroundColor: colors.White }, (ownerState.color === 'error'
                    ? {
                        '&:hover': {
                            boxShadow: 'unset',
                            backgroundColor: colors.Error100,
                            borderColor: theme.palette.error.dark,
                            color: theme.palette.error.dark,
                        },
                        '&:active': {
                            boxShadow: 'unset',
                            borderColor: colors.Error800,
                            backgroundColor: colors.Error100,
                            color: colors.Error800,
                        },
                    }
                    : ownerState.color === 'primary'
                        ? {
                            '&:hover': {
                                boxShadow: 'unset',
                                backgroundColor: (_d = tokens.uiElementButton.lightHoverColor) !== null && _d !== void 0 ? _d : colors.Gray100,
                                borderColor: theme.palette.primary.dark,
                                color: theme.palette.primary.dark,
                            },
                            '&:active': {
                                boxShadow: 'unset',
                                borderColor: colors.Primary700,
                                backgroundColor: (_e = tokens.uiElementButton.lightHoverColor) !== null && _e !== void 0 ? _e : colors.Gray100,
                                color: colors.Primary700,
                            },
                        }
                        : {})) : {})), (((_f = ownerState.variant) === null || _f === void 0 ? void 0 : _f.startsWith('text'))
                ? Object.assign(Object.assign({}, (ownerState.color === 'error'
                    ? {
                        '&:hover': {
                            color: theme.palette.error.dark,
                        },
                        '&:active': {
                            backgroundColor: colors.Gray100,
                            color: colors.Error800,
                        },
                    }
                    : ownerState.color === 'primary'
                        ? {
                            '&:hover': {
                                backgroundColor: (_g = tokens.uiElementButton.lightHoverColor) !== null && _g !== void 0 ? _g : colors.Gray100,
                                color: theme.palette.primary.dark,
                            },
                            '&:active': {
                                backgroundColor: (_h = tokens.uiElementButton.lightHoverColor) !== null && _h !== void 0 ? _h : colors.Gray100,
                                color: colors.Primary700,
                            },
                        }
                        : {})), { '&:hover': Object.assign({}, (ownerState.color === 'error'
                        ? { color: theme.palette.error.dark }
                        : ownerState.color === 'primary'
                            ? { color: theme.palette.primary.dark }
                            : {})) }) : {})));
        },
        // NOTE: Broken atm. https://github.com/mui/material-ui/issues/29644
        disabled: {},
        startIcon: () => ({
            color: 'inherit',
            margin: '0px',
        }),
        endIcon: () => ({
            color: 'inherit',
            margin: '0px',
        }),
        sizeSmall: ({ ownerState }) => {
            const { sizeSmall } = tokens.uiElementButton;
            const leftPadding = ownerState.startIcon
                ? sizeSmall.paddingForIcon
                : sizeSmall.padding;
            const rightPadding = ownerState.endIcon
                ? sizeSmall.paddingForIcon
                : sizeSmall.padding;
            return {
                fontSize: sizeSmall.fontSize,
                fontWeight: baseTypography.weight.Medium,
                lineHeight: baseTypography.height.Small,
                height: sizeSmall.height,
                padding: '0px ' + rightPadding + ' 0px ' + leftPadding,
                gap: sizeSmall.gap,
            };
        },
        sizeMedium: ({ ownerState }) => {
            const { sizeMedium } = tokens.uiElementButton;
            const leftPadding = ownerState.startIcon
                ? sizeMedium.paddingForIcon
                : sizeMedium.padding;
            const rightPadding = ownerState.endIcon
                ? sizeMedium.paddingForIcon
                : sizeMedium.padding;
            return {
                fontSize: sizeMedium.fontSize,
                fontWeight: baseTypography.weight.Medium,
                lineHeight: baseTypography.height.Small,
                height: sizeMedium.height,
                padding: '0px ' + rightPadding + ' 0px ' + leftPadding,
                gap: sizeMedium.gap,
            };
        },
        sizeLarge: ({ ownerState }) => {
            const { sizeLarge } = tokens.uiElementButton;
            const leftPadding = ownerState.startIcon
                ? sizeLarge.paddingForIcon
                : sizeLarge.padding;
            const rightPadding = ownerState.endIcon
                ? sizeLarge.paddingForIcon
                : sizeLarge.padding;
            return {
                fontSize: sizeLarge.fontSize,
                fontWeight: baseTypography.weight.Medium,
                lineHeight: baseTypography.height.Small,
                height: sizeLarge.height,
                padding: '0px ' + rightPadding + ' 0px ' + leftPadding,
                gap: sizeLarge.gap,
            };
        },
    },
});
const loadingButtonStyles = {
    styleOverrides: {
        // NOTE: root is a function and we are using _.merge, overwrite root manually
        root: ({ ownerState }) => ({
            minWidth: 'unset',
            boxShadow: 'none',
            textTransform: 'unset',
            // NOTE: For some reason disabled property in overrides will not include these, that's why this is here
            // https://github.com/mui/material-ui/issues/29644
            '&.Mui-disabled': {
                borderColor: ownerState.variant === 'contained' ? colors.Gray600 : colors.Gray300,
                // MATTI-TODO: Halutaanko oikeasti iso gray-600 text-variantille?
            },
        }),
        loadingIndicator: ({ ownerState }) => ({
            color: ownerState.variant === 'contained' ? colors.White : colors.Gray600,
            [`& > .${circularProgressClasses.root}`]: {
                width: (ownerState.size === 'small'
                    ? spacing[500].px
                    : ownerState.size === 'medium'
                        ? spacing[600].px
                        : spacing[700].px) + ' !important',
                height: (ownerState.size === 'small'
                    ? spacing[500].px
                    : ownerState.size === 'medium'
                        ? spacing[600].px
                        : spacing[700].px) + ' !important', // TODO: remove important somehow
            },
        }),
    },
};
export const getThemeButtons = (tokens) => {
    const buttonStyles = getButtonStyles(tokens);
    return {
        MuiLoadingButton: merge({}, buttonStyles, loadingButtonStyles),
        MuiButton: buttonStyles,
        // NOTE: Button with Icon works better for our purposes than IconButton
        MuiIconButton: {
            styleOverrides: {
                root: {
                    borderRadius: tokens.uiElementButton.borderRadius,
                    '&:hover': {
                        backgroundColor: 'white',
                    },
                    '[class*="MuiSvgIcon-root"]': { fontSize: 'inherit' },
                    // TODO: IconButton is used in e.g. DatePicker buttons, these pixels fit there fine but otherwise probably won't
                    '&.Mui-focusVisible': Object.assign(Object.assign({}, focusVisible), { outlineOffset: '-4px' }),
                },
            },
        },
        MuiButtonBase: {
            defaultProps: {
                disableRipple: true,
            },
        },
    };
};
